import { msg } from '@lingui/core/macro';

import { BILLING_STATUS } from '@/modules/billing/public';
import { walletSource } from '@/modules/wallet/public';
import { defineFilters } from '@/shared/filters/define-filters';
import { stripDocumentSeparators } from '@/shared/format/internal';

import { INSTALLMENT_STATUS, PROTEST_INSTRUCTION } from './installment.enums';

const iso = (day: string) => new Date(`${day}T00:00:00-03:00`).toISOString();

/** Filtros da lista, na ordem do "Filtrar por" do legado (`InstallmentFilters.tsx:28-43`). */
export const installmentFilters = defineFilters([
  { key: 'walletsCode', type: 'entity', source: walletSource(), multiple: true, label: msg`Código convênio` },
  { key: 'statusesValue', type: 'status', label: msg`Status`, options: INSTALLMENT_STATUS },
  {
    key: 'initialCreatedDate',
    to: 'finalCreatedDate',
    type: 'dateRange',
    label: msg`Data de criação`,
    fromParam: iso,
  },
  { key: 'payerName', type: 'text', label: msg`Nome do devedor` },
  { key: 'payerRegistrationNumber', type: 'document', label: msg`CPF/CNPJ do devedor`, toParam: stripDocumentSeparators },
  { key: 'firstInstructionDebtCollection', type: 'select', label: msg`Instrução de protesto`, options: PROTEST_INSTRUCTION },
  { key: 'billingCount', type: 'text', label: msg`Quantidade de parcelas` },
  { key: 'operation', type: 'text', label: msg`Identificador do contrato` },
] as const);

/** Filtros das cobranças do parcelamento (`InsatallmentBillingsList.tsx:146-153`). */
export const installmentBillingFilters = defineFilters([
  { key: 'searchString', type: 'search', label: msg`Todos` },
  { key: 'statusesValue', type: 'status', label: msg`Status`, options: BILLING_STATUS },
  {
    key: 'initialDueDate',
    to: 'finalDueDate',
    type: 'dateRange',
    label: msg`Data de vencimento`,
    fromParam: iso,
    toParam: iso,
  },
  {
    key: 'initialSettlementDate',
    to: 'finalSettlementDate',
    type: 'dateRange',
    label: msg`Data do crédito`,
    fromParam: iso,
  },
  { key: 'barCode', type: 'text', label: msg`Código de barras` },
  { key: 'documentNumber', type: 'text', label: msg`Nº do documento` },
] as const);
